export default "__VITE_ASSET__1a6ac422__"